import React from 'react';
import { Container } from 'components/UI';
import IntroDefault from './IntroDefault';
import { getMeetupDateString } from 'utils';

import { MEETUP_TIME } from 'define';

import * as styles from './Intro.module.scss';

export default function Intro({ customDate, showDefaultIntro, ...props }) {
  const preparedProps = {
    ...props,
    date: customDate ?? getMeetupDateString(),
    meetupStartTime: MEETUP_TIME,
  };

  return (
    <Container className={styles.container} background="transparent">
      <IntroDefault {...preparedProps} />
    </Container>
  );
}
